<div
  *transloco="let t; read: 'action-item-list-filter'"
  class="xi-modal__container action-item-list-filter__container"
>
  <h2 class="xi-modal__title">
    {{
      t('title', {
        type: isActionItem ? t('action-item') : t('task'),
      })
    }}
  </h2>

  <form
    autocomplete="off"
    [formGroup]="form"
    class="xi-modal__content action-item-list-filter__content"
  >
    <div class="action-item-list-filter__section">
      <span class="action-item-list-filter__label">{{ t('due-date') }}</span>

      <div class="action-item-list-filter__due-date">
        <xi-checkbox
          color="CX"
          formControlName="isDueDate"
          class="action-item-list-filter__due-date-checkbox"
        >
        </xi-checkbox>

        <xi-calendar
          [popoutView]="true"
          [data]="calendarData"
          [checkedListId]="calendarRelativeId"
          [mode]="calendarMode"
          (onValueChange)="onCalendarValueChange($event.detail)"
          class="action-item-list-filter__calendar"
          [class.kxi-calendar--disabled]="!form.controls.isDueDate.value"
        >
        </xi-calendar>
      </div>
    </div>

    <div class="action-item-list-filter__section">
      <span class="action-item-list-filter__label">{{ t('status') }}</span>

      <div class="action-item-list-filter__statuses">
        <xi-checkbox color="CX" [label]="t('not-started')" formControlName="isNotStarted">
        </xi-checkbox>

        <xi-checkbox color="CX" [label]="t('in-progress')" formControlName="isInProgress">
        </xi-checkbox>

        <xi-checkbox color="CX" [label]="t('completed')" formControlName="isCompleted">
        </xi-checkbox>
      </div>
    </div>

    <div class="action-item-list-filter__section">
      <span class="action-item-list-filter__label">{{ t('assignee') }}</span>

      <div class="action-item-list-filter__assignee-wrapper">
        <xi-input-field formControlName="assignee"></xi-input-field>
      </div>
    </div>
  </form>

  <div class="xi-modal__actions">
    <xi-default-button [text]="t('cancel')" fill="text" (onClick)="onCancel()"></xi-default-button>

    <xi-default-button [text]="t('apply')" [disabled]="isInvalid" (onClick)="onApply()">
    </xi-default-button>
  </div>
</div>
